import classNames from 'classnames';
import React from 'react';
import { useTheme } from 'styled-components';
import { useDescriptionsContext } from '../../descriptions.context';
import { descriptionsClasses } from '../../descriptions.styled';

interface DescriptionsIconProps {
  Icon: (p: React.SVGProps<SVGSVGElement>) => JSX.Element;
  className?: string;
  color?: string;
}

const DescriptionsIcon: React.FunctionComponent<DescriptionsIconProps> = ({
  Icon,
  className,
  color,
}) => {
  const context = useDescriptionsContext();
  const theme = useTheme();

  return (
    <Icon
      width={24}
      height={24}
      color={
        color
          ? color
          : context.variant === 'on-dark'
          ? theme.color.tint.actionDark
          : theme.color.tint.action
      }
      className={classNames(descriptionsClasses.iconItem, className)}
    />
  );
};

export default DescriptionsIcon;
